import { HeroSection } from '../components/HeroSection';
import { SmartphoneMockup } from '../components/SmartphoneMockup';
import { ValuePropTags } from '../components/ValuePropTags';
import { TestimonialsSection } from '../components/TestimonialsSection';
import { DownloadCTA } from '../components/DownloadCTA';
import { Footer } from '../components/Footer';
import { Header } from '../components/Header';

export default function App() {
  return (
    <div 
      className="min-h-screen relative"
      style={{
        background: 'linear-gradient(135deg, rgba(33, 150, 243, 0.12) 0%, rgba(46, 182, 125, 0.10) 50%, rgba(255, 110, 58, 0.15) 100%)'
      }}
    >
      <Header />
      <HeroSection />
      <SmartphoneMockup />
      <ValuePropTags />
      <TestimonialsSection />
      <DownloadCTA />
      <Footer />
    </div>
  );
} 